export const opportunityFieldsMap = [
  { label: 'Título', value: 'title' },
  { label: 'Fase', value: 'stageName' },
  { label: 'Conta', value: 'accountName' },
  { label: 'Valor', value: 'amount' },
  { label: 'Criado (Responsável)', value: 'createdByName' },
  { label: 'Criado (Data)', value: 'createdAt' },
  { label: 'Última atualização (Responsável)', value: 'lastUpdatedByName' },
  { label: 'Última atualização (Data)', value: 'lastUpdatedAt' },
  { label: 'Responsável', value: 'responsibleName' },
  { label: 'Mudança de fase (Data)', value: 'changedStageAt' },
  { label: 'Contato', value: 'contactName' },
  { label: 'Oportunidade convertida', value: 'convertOpportunityId' },
  { label: 'Catálogo', value: 'catalogName' },
  { label: 'valor Total do Catálogo', value: 'catalogTotalValue' }
];

export const dataPeriod = [
  { label: 'Este ano', value: 'thisYear' },
  { label: 'Ano passado', value: 'lastYear' },
  { label: 'Última semana', value: 'lastWeek' },
  { label: 'Hoje', value: 'today' },
  { label: 'Ontem', value: 'yesterday' },
  { label: 'Última 7 dias', value: 'last7Days' },
  { label: 'Esta semana', value: 'thisWeek' },
  { label: 'Este mês', value: 'thisMonth' },
  { label: 'Mês passado', value: 'lastMonth' },
  { label: 'Trimestre passado', value: 'lastQuarter' },
  { label: 'Esse Trimestre', value: 'thisQuarter' },
  { label: 'Intervalo de datas', value: 'dateRange' }
];

export const chartTypes = [
  { label: 'Barra', value: 'bar' },
  { label: 'Coluna', value: 'column' },
  { label: 'Pizza', value: 'pie' },
  { label: 'Rosquinha', value: 'Doughnut' },
  { label: 'Linha', value: 'line' }
];

export const dataTypes = [
  { label: 'Soma', value: 'sum' },
  { label: 'Media', value: 'average' },
  { label: 'Contagem', value: 'count' }
];

export const allowedFields = [
  { label: 'Fase da Oportunidade', value: 'stageId' },
  { label: 'Responsável', value: 'responsibleLogin' },
  { label: 'Motivo de Perda', value: 'lostReason' },
  { label: 'Tipo de Oportunidade', value: 'type' },
  { label: 'Contato', value: 'contactId' },
  { label: 'Conta', value: 'accountId' }
];
